import { ReconcileReasonCatchWeight, ReconcileReasonItem } from "components/item-verification";
import { TripContext } from "contexts";
import React, { FC, Fragment, useContext } from "react";
import { useOrderItemService } from "services";
import { CatchWeight, OrderItemChange } from "services/types";

type Props = {
  orderItemId: number
};

export const ReconcileReasonCard: FC<Props> = ({ orderItemId }) => {

  const tripContext = useContext(TripContext)
  const { formatChange } = useOrderItemService()

  const orderItemsChanges: OrderItemChange[] = tripContext.orderItemChanges.filter(change => change.orderItemId == orderItemId).sort((a, b) => a.reconcileReasonId < b.reconcileReasonId ? -1 : a.reconcileReasonId > b.reconcileReasonId ? 1 : 0) ?? []
  const catchWeights: CatchWeight[] = tripContext.catchWeights.filter(weight => weight.orderItemId == orderItemId) ?? []

  return (
    <Fragment>
      <div className={'reconcile-reason-grid-heading'}>
        <div className={'reconcile-reason-grid-text-heading'} style={{ width: '45%' }}>Reconcile</div>
        <div className={'reconcile-reason-grid-text-heading'} style={{ width: '40%' }}>Rtn Sticker</div>
        <div className={'reconcile-reason-grid-text-heading'} style={{ width: '15%' }}>{catchWeights.length > 0 ? 'Lbs' : 'Qty'}</div>
      </div>
      {catchWeights.length > 0 ?
        <Fragment>
          {catchWeights.filter(cw => cw.reconcileReasonId != null && cw.reconcileReasonId > 0).map((catchWeight) => (
            <ReconcileReasonCatchWeight key={catchWeight.id} catchWeightId={catchWeight.id} />
          ))}
        </Fragment>
        :
        <Fragment>
          {orderItemsChanges.map((change, changeIndex) => {
            const formattedChanges = formatChange(change)
            return formattedChanges.map((formattedChange, formattedIndex) => {
              const [description, quantity] = formattedChange
              return quantity > 0 &&
              <ReconcileReasonItem
                key={`${changeIndex}-${formattedIndex}`}
                orderItemsChangeId={change.id}
                reconcileDescription={description}
                quantity={quantity}
              />
            })
          })}
        </Fragment>
      }
    </Fragment>
  )
}
